import {
  getMaxColumns,
  GRID_GUTTER_WIDTH,
  GRID_ITEM_WIDTH,
  MIN_COLUMNS,
} from 'app/common/lib/react/gridUtils';

export default function cssStyles(seoUnauthExperiments, pinCount, isBoard) {
  let styles = '';
  const minColumns = MIN_COLUMNS;
  const maxColumns = getMaxColumns(pinCount);
  const itemMargin = GRID_GUTTER_WIDTH;
  const itemWidth = GRID_ITEM_WIDTH + itemMargin;
  let minWidth = 0;
  let maxWidth = minColumns * itemWidth + itemWidth - 1;

  for (let i = minColumns; i < maxColumns + 1; i += 1) {
    styles += `
@media (min-width: ${minWidth}px) and (max-width: ${maxWidth}px) {
  .static:nth-child(-n+${i}) {
    float: left;
    position: static;
    display: block;
    visibility: visible;
    margin: 0 ${itemMargin / 2}px;
  }
  .gridCentered {
    width: ${i * itemWidth}px;
  }
}
`;
    minWidth = maxWidth + 1;
    maxWidth += itemWidth;
  }
  styles += `
.static {
  position: absolute;
  visibility: hidden;
}
.gridCentered {
  margin: 0 auto;
}
.Grid__Container {
    height: 100%;
    margin: 0 auto;
    position: relative;
}

.Grid__Item {
    position: absolute;
}
`;
  return styles;
}
